<template lang="pug">
  div.e-image-viewer
    div(
    v-if="images && images.length > 0"
    ).images
      el-carousel(
      type="card"
      :autoplay="false"
      :height="height"
      )
        el-carousel-item(
        v-for="imageUrl, imageIndex in images"
        :key="imageIndex"
        ).image
          img(
          :src="imageUrl"
          )
    div(
    v-else
    ).no-data Нет изображений
</template>

<script>
  export default {
    name: 'e-image-viewer',
    data: () => ({
      innerHeight: 0
    }),
    props: {
      imagesArray: {
        type: Array,
        default: function () {
          return []
        }
      },
      offset: {
        type: Number,
        default: 360
      }
    },
    created () {
      window.addEventListener('resize', this.onResize)
      this.onResize()
    },
    destroyed () {
      window.removeEventListener('resize', this.onResize)
    },
    methods: {
      onResize () {
        this.innerHeight = window.innerHeight
      }
    },
    computed: {
      height () {
        let h = this.innerHeight - this.offset
        return `${h}px`
      },
      images () {
        return this.imagesArray || []
      }
    }
  }
</script>
